import React from "react";
import { Helmet } from "react-helmet-async";

interface OpenGraphTags {
  title?: string;
  description?: string;
  url?: string;
  type?: string;
  site_name?: string;
  image?: string;
  imageWidth?: string;
  imageHeight?: string;
}

interface MetaTagsProps {
  title: string;
  description: string;
  canonical: string;
  robots?: string;
  og?: OpenGraphTags;
}

const MetaTags: React.FC<MetaTagsProps> = ({
  title,
  description,
  canonical,
  robots = "index, follow",
  og = {},
}) => {
  return (
    <Helmet>
      {/* Title */}
      <title>{title}</title>

      {/* Standard meta tags */}
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph Tags */}
      {og.title && <meta property="og:title" content={og.title} />}
      {og.description && (
        <meta property="og:description" content={og.description} />
      )}
      {og.url && <meta property="og:url" content={og.url} />}
      {og.type && <meta property="og:type" content={og.type} />}
      {og.site_name && <meta property="og:site_name" content={og.site_name} />}
      {og.image && <meta property="og:image" content={og.image} />}
      {og.imageWidth && (
        <meta property="og:image:width" content={og.imageWidth} />
      )}
      {og.imageHeight && (
        <meta property="og:image:height" content={og.imageHeight} />
      )}
    </Helmet>
  );
};

export default MetaTags;
